Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    paragraph = _STYLES$useStyles.paragraph;
  var container = {
    width: '100%',
    maxWidth: (0, _styles.getREM)(31.5625)
  };
  var bubble = {
    borderRadius: (0, _styles.getREM)(1.25),
    padding: (0, _styles.getREM)(1.25),
    marginBottom: (0, _styles.getREM)(2.25),
    position: 'relative'
  };
  if (bp.mobile_xs) {
    bubble.borderRadius = (0, _styles.getREM)(0.5);
    bubble.padding = (0, _styles.getREM)(0.5);
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    bubble.padding = (0, _styles.getREM)(1.875);
  }
  var triangle = {
    position: 'absolute',
    zIndex: 0,
    bottom: (0, _styles.getREM)(-1.663125),
    right: (0, _styles.getREM)(1.5625),
    width: (0, _styles.getREM)(2.5),
    height: (0, _styles.getREM)(2.163125)
  };
  var pill = {
    marginBottom: (0, _styles.getREM)(1)
  };
  var textContainer = {
    marginBottom: _reactNative.Platform.OS === 'web' ? "calc(".concat(paragraph.fontSize, " * -2)") : paragraph.fontSize * -2
  };
  var characterContainer = {
    width: (0, _styles.getREM)(5.625),
    height: (0, _styles.getREM)(5.625),
    borderRadius: (0, _styles.getREM)(2.8125),
    overflow: 'hidden',
    position: 'relative',
    alignSelf: 'flex-end'
  };
  var character = {
    position: 'absolute',
    left: (0, _styles.getREM)(0.5),
    top: (0, _styles.getREM)(1),
    width: '100%',
    height: '121%'
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    bubble: bubble,
    triangle: triangle,
    pill: pill,
    textContainer: textContainer,
    characterContainer: characterContainer,
    character: character
  });
  return {
    styles: styles
  };
};